<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> OPORTUNIDADE DE COMPRA FORNECEDOR </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="promotion.id"
          >{{ promotion.id }} -
          {{
            promotion.description.substring(0, 30).toUpperCase()
          }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="grey darken-3"
          @click="goToBackList()"
          v-if="tab == 1"
        >
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :visible="!!alert_message"
        dark
        :type="type_alert"
        :message="alert_message"
        :clickClose="() => (alert_message = '')"
      />
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-stepper v-model="tab">
          <v-stepper-header>
            <v-stepper-step :complete="tab > 1" step="1">
              Dados da Promoção
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="tab > 2" step="2">
              Seleção de Produtos
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="tab > 3"
              step="3"
              :disabled="promotion.type !== 3"
            >
              <v-badge
                color="red"
                :content="products.length"
                :value="products.length > 0"
              >
                Desconto de Produto
              </v-badge>
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="4">
              <v-badge
                color="red"
                :content="products.length"
                :value="products.length > 0"
              >
                Produtos em Promoção
              </v-badge>
            </v-stepper-step>
          </v-stepper-header>
          <!-- <v-tabs v-model="tab" background-color="grey lighten-2">
          <v-tab key="home">Dados da Promoção</v-tab>
          <v-tab key="products_selection">Seleção de Produtos</v-tab>
          <v-tab key="products">
            <v-badge
              color="red"
              :content="products.length"
              :value="products.length > 0"
            >
              Produtos em Promoção
            </v-badge>
          </v-tab>
        </v-tabs> -->
          <v-container fluid>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-row>
                  <v-col></v-col>
                </v-row>
                <v-row>
                  <v-col class="py-2" cols="12" xs="12" sm="6" md="3">
                    <v-select
                      :items="providers"
                      v-model="promotion.provider_id"
                      label="Fornecedor"
                      :item-text="(item) => `${item.code} - ${item.name}`"
                      item-value="id"
                      clearable
                      dense
                      outlined
                      required
                      :rules="[rules.required]"
                      :loading="loading_providers"
                      :disabled="promotion.id !== ''"
                    ></v-select>
                  </v-col>
                  <v-col class="py-2" cols="12" xs="12" sm="6" md="3">
                    <v-select
                      :items="typePromotions"
                      v-model="promotion.type"
                      label="Tipo de Oportunidade"
                      dense
                      outlined
                      required
                      :rules="[rules.required]"
                      :loading="loading_providers"
                      :disabled="promotion.id !== ''"
                    ></v-select>
                  </v-col>
                  <v-col class="py-2" cols="12" xs="12" sm="6" md="3">
                    <v-text-field
                      v-mask="date_mask"
                      outlined
                      dense
                      v-model="promotion.start_date"
                      label="Data Inicial"
                      append-outer-icon="mdi-calendar"
                      @click:append-outer="handlerCalendar('start_date')"
                      required
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-2" cols="12" xs="12" sm="6" md="3">
                    <v-text-field
                      v-mask="date_mask"
                      outlined
                      dense
                      label="Data Final"
                      v-model="promotion.end_date"
                      append-outer-icon="mdi-calendar"
                      @click:append-outer="handlerCalendar('end_date')"
                      required
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-2" cols="12" xs="12" sm="6" md="6" lg="6">
                    <v-text-field
                      outlined
                      dense
                      class="fs-12 text-field-uppercase"
                      label="Descrição da oportunidade"
                      v-model="promotion.description"
                      required
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-2" cols="12" xs="12" sm="6" md="3" lg="2">
                    <v-switch
                      v-model="promotion.status"
                      :label="`Status: ${getLabelStatus(promotion.status)}`"
                      class="mt-1"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row v-if="promotion.type == 1">
                  <v-col class="py-2" cols="12" xs="12" md="4">
                    <v-radio-group
                      v-model="radio_payment_condition"
                      class="my-0"
                      hide-details
                      dense
                    >
                      <template v-slot:label>
                        <div>
                          Selecione se a promoção será para todas as condições
                          ou somente para uma.
                        </div>
                      </template>
                      <v-radio
                        key="one"
                        :label="`Somente uma Condição de Pagamento`"
                        value="one"
                      ></v-radio>
                      <v-radio
                        key="all"
                        :label="`Todas as Condições de Pagamento Cadastradas`"
                        value="all"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col class="py-2" cols="12" xs="12" md="3">
                    <v-autocomplete
                      :items="payment_conditions"
                      item-text="name"
                      item-value="id"
                      v-model="promotion.payment_condition_id"
                      label="Condição de Pagamento"
                      dense
                      outlined
                      :disabled="radio_payment_condition === 'all'"
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-2" cols="12" xs="12" md="2" lg="1">
                    <v-text-field
                      outlined
                      dense
                      class="fs-12"
                      label="Desconto"
                      v-model.number="promotion.discount"
                      suffix="%"
                      required
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="promotion.type === 2">
                  <v-col class="py-2" cols="12" xs="12" md="3">
                    <v-autocomplete
                      :items="payment_conditions"
                      item-text="name"
                      item-value="id"
                      v-model="promotion.payment_condition_id"
                      label="Condição de Pagamento"
                      dense
                      outlined
                      :disabled="radio_payment_condition === 'all'"
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-2" cols="12" xs="12" md="2" lg="1">
                    <v-text-field
                      outlined
                      dense
                      class="fs-12"
                      label="Desconto"
                      v-model.number="promotion.discount"
                      suffix="%"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      color="primary"
                      outlined
                      class="mt-2"
                      @click="goToPageTwo()"
                    >
                      Avançar <v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-row v-if="promotion.type != 3">
                  <v-col>
                    <v-radio-group
                      v-model="radio_products"
                      class="my-0"
                      hide-details
                      dense
                      row
                    >
                      <v-radio
                        key="some_products"
                        label="Selecionar Produtos"
                        value="some_products"
                      ></v-radio>
                      <v-radio
                        key="all_products"
                        label="Todos os Produtos"
                        value="all_products"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-expansion-panels
                      v-model="panel"
                      v-if="radio_products == 'some_products'"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <label class="subtitle-1 font-weight-bold">
                            Filtros
                          </label>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-select
                                :items="collections"
                                v-model="search.collection"
                                no-data-text="Não tem produto cadastrado para esse fornecedor"
                                label="Coleção"
                                :item-text="(item) => `${item.name}`"
                                item-value="id"
                                hide-details
                                clearable
                                dense
                                outlined
                                :loading="loading_collections"
                              ></v-select>
                            </v-col>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-select
                                :items="categories"
                                v-model="search.category"
                                no-data-text="Não tem produto cadastrado para esse fornecedor"
                                label="Categoria"
                                :item-text="(item) => `${item.name}`"
                                item-value="id"
                                hide-details
                                clearable
                                dense
                                outlined
                                :loading="loading_categories"
                              ></v-select>
                            </v-col>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-select
                                :items="subcategories"
                                v-model="search.subcategory"
                                no-data-text="Não tem produto cadastrado para esse fornecedor"
                                label="Subcategoria"
                                :item-text="(item) => `${item.name}`"
                                item-value="id"
                                hide-details
                                clearable
                                dense
                                outlined
                                :loading="loading_subcategories"
                              ></v-select>
                            </v-col>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-select
                                v-model="search.technologies"
                                no-data-text="Não tem produto cadastrado para esse fornecedor"
                                :items="technologies"
                                :item-text="(item) => `${item.name}`"
                                item-value="id"
                                chips
                                label="Tecnologias"
                                hide-details
                                clearable
                                multiple
                                dense
                                outlined
                                :loading="loading_technologies"
                              >
                                <template v-slot:selection="{ item, index }">
                                  <span v-if="index === 0"
                                    >{{ item.name }} &nbsp;</span
                                  >
                                  <span v-if="index === 1" class="text-caption">
                                    [ +{{ search.technologies.length - 1 }}
                                    outro(s) ]
                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-select
                                v-model="search.material"
                                no-data-text="Não tem produto cadastrado para esse fornecedor"
                                :items="materials"
                                label="Material"
                                :item-text="
                                  (item) => `${item.code} - ${item.name}`
                                "
                                item-value="id"
                                hide-details
                                clearable
                                dense
                                outlined
                                :loading="loading_materials"
                              ></v-select>
                            </v-col>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-select
                                v-model="search.color"
                                no-data-text="Não tem produto cadastrado para esse fornecedor"
                                :items="colors"
                                label="Cor"
                                :item-text="
                                  (item) => `${item.code} - ${item.name}`
                                "
                                item-value="id"
                                hide-details
                                clearable
                                dense
                                outlined
                                :loading="loading_colors"
                              ></v-select>
                            </v-col>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-text-field
                                v-model="search.reference"
                                class="text-field-uppercase"
                                label="Referência"
                                hide-details
                                dense
                                outlined
                              ></v-text-field>
                            </v-col>
                            <v-col class="d-flex py-2" cols="12" sm="6" md="3">
                              <v-btn
                                color="green darken-3"
                                class="white--text"
                                @click="searchProductAdvanced()"
                              >
                                <v-icon left>mdi-magnify</v-icon>
                                Buscar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <label class="subtitle-1 font-weight-bold">
                            Produtos
                          </label>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row v-if="!!alert_add_product">
                            <v-col>
                              <alert
                                :visible="!!alert_add_product"
                                dark
                                type="success"
                                :message="alert_add_product"
                                :clickClose="() => (alert_add_product = '')"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-data-table
                                v-model="selected"
                                :headers="headers_products_search"
                                :items="products_search"
                                :items-per-page="20"
                                item-key="reference"
                                class="elevation-1"
                                show-select
                                dense
                                :loading="loading_search"
                              >
                                <template v-slot:[`item.photo`]="{ item }">
                                  <v-img
                                    :src="getUrlPhoto(item.photo)"
                                    alt=""
                                    max-width="120"
                                    :aspect-ratio="16 / 9"
                                    class="my-2 image-clickable"
                                    @click="
                                      onClickImage(getUrlPhoto(item.photo))
                                    "
                                  ></v-img>
                                </template>
                                <template v-slot:[`item.reference`]="{ item }">
                                  {{ item.provider_code }}{{ item.reference }}
                                </template>
                                <!-- eslint-disable-next-line -->
                                <template v-slot:footer.prepend>
                                  <v-btn
                                    color="green darken-3 mt-2"
                                    class="white--text"
                                    small
                                    @click="addProduct()"
                                  >
                                    <v-icon left>mdi-plus</v-icon>
                                    Adicionar Produtos na Promoção
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                          <v-row v-if="radio_products != 'some_products'">
                            <v-col class="mt-5"></v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-btn color="gray" outlined class="mt-2" @click="tab = 1">
                      <v-icon left>mdi-chevron-left</v-icon>
                      Voltar
                    </v-btn>
                    <v-btn
                      color="primary"
                      outlined
                      class="mt-2 ml-4"
                      v-if="radio_products === 'some_products'"
                      @click="goToPageTree()"
                    >
                      Avançar <v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-btn
                      color="blue darken-3"
                      dark
                      class="mt-2 ml-4"
                      v-if="radio_products !== 'some_products'"
                      @click="validate()"
                    >
                      Salvar <v-icon right>mdi-send</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-row>
                  <v-col cols="12">
                    <label class="text-h6"
                      >{{
                        radio_products === "some_products"
                          ? "Produtos em Promoção"
                          : "Todos os Produtos estão nesta Promoção"
                      }}
                    </label>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row v-if="radio_products == 'some_products'">
                  <v-col>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Referencia</th>
                            <th class="text-left">Nome</th>
                            <th class="text-right column-price">R$ Rede</th>
                            <th class="text-right column-price">
                              Novo R$ Rede
                            </th>
                            <th class="text-right column-percent">(%) Rede</th>
                            <th class="text-right column-price">
                              R$ Multimarcas
                            </th>
                            <th class="text-right column-price">
                              Novo R$ Multimarcas
                            </th>
                            <th class="text-right column-percent">
                              (%) Multimarcas
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in products" :key="item.key">
                            <td>
                              {{ item.provider_code }} {{ item.reference }}
                            </td>
                            <td>{{ item.name }}</td>
                            <td class="text-right">
                              {{ item.price_cif | currencyEuaToBr }}
                            </td>
                            <td class="text-right">
                              <v-text-field
                                hide-details
                                outlined
                                reverse
                                dense
                                class="my-2"
                                v-mask="'money'"
                                v-model="item.new_price_cif"
                                @blur="handleChangePrice(item, 'cif')"
                              ></v-text-field>
                            </td>
                            <td class="text-right">
                              {{ item.percent_cif | formatPercent }}%
                            </td>
                            <td class="text-right">
                              {{ item.price_mult | currencyEuaToBr }}
                            </td>
                            <td class="text-right">
                              <v-text-field
                                hide-details
                                outlined
                                reverse
                                dense
                                class="my-2"
                                v-mask="'money'"
                                v-model="item.new_price_mult"
                                @blur="handleChangePrice(item, 'mult')"
                              ></v-text-field>
                            </td>
                            <td class="text-right">
                              {{ item.percent_mult | formatPercent }}%
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn color="gray" outlined class="mt-2" @click="tab = 2">
                      <v-icon left>mdi-chevron-left</v-icon>
                      Voltar
                    </v-btn>
                    <v-btn
                      color="primary"
                      outlined
                      class="mt-2 ml-4"
                      @click="goToPageFour()"
                    >
                      Avançar <v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>
              <v-stepper-content step="4">
                <v-row>
                  <v-col cols="12">
                    <label class="text-h6"
                      >{{
                        radio_products === "some_products"
                          ? "Produtos em Promoção"
                          : "Todos os Produtos estão nesta Promoção"
                      }}
                    </label>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row v-if="radio_products == 'some_products'">
                  <v-col>
                    <v-data-table
                      :headers="headers_products"
                      :items="products"
                      :items-per-page="20"
                      item-key="key"
                      class="elevation-1"
                      dense
                    >
                      <template v-slot:[`item.photo`]="{ item }">
                        <v-img
                          :src="getUrlPhoto(item.photo)"
                          alt=""
                          max-width="120"
                          :aspect-ratio="16 / 9"
                          class="my-2 image-clickable"
                          @click="onClickImage(getUrlPhoto(item.photo))"
                        ></v-img>
                      </template>
                      <template v-slot:[`item.reference`]="{ item }">
                        {{ item.provider_code }}{{ item.reference }}
                      </template>
                      <template v-slot:[`item.price_cif`]="{ item }">
                        {{ item.price_cif | currencyEuaToBr }}
                      </template>
                      <template v-slot:[`item.new_price_cif`]="{ item }">
                        R$ {{ item.new_price_cif }}
                      </template>
                      <template v-slot:[`item.percent_cif`]="{ item }">
                        {{ item.percent_cif | formatPercent }}
                      </template>
                      <template v-slot:[`item.price_mult`]="{ item }">
                        {{ item.price_mult | currencyEuaToBr }}
                      </template>
                      <template v-slot:[`item.new_price_mult`]="{ item }">
                        R$ {{ item.new_price_mult }}
                      </template>
                      <template v-slot:[`item.percent_mult`]="{ item }">
                        {{ item.percent_mult | formatPercent }}
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top color="error">
                          <!-- eslint-disable-next-line -->
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="red darken-1"
                              @click="deleteProduct(item)"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Remover</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row v-if="radio_products != 'some_products'">
                  <v-col class="mt-12"></v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      color="gray"
                      outlined
                      class="mt-2"
                      @click="goBackTab4()"
                    >
                      <v-icon left>mdi-chevron-left</v-icon>
                      Voltar
                    </v-btn>
                    <v-btn
                      color="blue darken-3"
                      dark
                      class="mt-2 ml-4"
                      @click="validate()"
                    >
                      Salvar <v-icon right>mdi-send</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>
            </v-stepper-items>
          </v-container>
        </v-stepper>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modal_date"
      :return-value.sync="date_dialog"
      width="290px"
    >
      <v-date-picker
        v-model="date_dialog"
        scrollable
        no-title
        @change="handlePickerDate()"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal_date = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
    <ImageZoom
      :visible="dialog_zoom_photo"
      :closeDialog="closeDialogZoomPhoto"
      :photo="photo_dialog"
    />
  </div>
</template>

<script>
import { URL, URL_IMAGE } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CompanyPromotionAPI from "@/api/requests/CompanyPromotionRequest";

import Alert from "@/components/Alert";
import ImageZoom from "@/components/ImageZoom";
import AwesomeMask from "awesome-mask";

export default {
  components: {
    Alert,
    ImageZoom,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    date_mask: "99/99/9999",
    loading: false,
    promotion: {
      id: "",
      provider_id: "",
      type: "",
      description: "",
      status: "1",
      start_date: "",
      end_date: "",
      payment_condition_id: "",
      discount: "",
      payment: null,
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    tab: 1,
    loading_providers: false,
    loading_collections: false,
    loading_categories: false,
    loading_subcategories: false,
    loading_materials: false,
    loading_colors: false,
    loading_technologies: false,
    loading_search: false,
    providers: [],
    typePromotions: [
      { value: 1, text: "Desconto na condição de pagamento" },
      { value: 2, text: "Promoção de prazo especial" },
      { value: 3, text: "Promoção de produtos (preço)" },
    ],
    payment_conditions: [],
    search: {
      collection: "",
      category: "",
      subcategory: "",
      material: "",
      color: "",
      technologies: "",
      reference: "",
    },
    categories: [],
    subcategories: [],
    collections: [],
    technologies: [],
    materials: [],
    colors: [],
    alert_message: "",
    type_alert: "",
    modal_date: false,
    date_dialog: "",
    field_date: "",
    radio_payment_condition: "one",
    selected: [],
    radio_products: "some_products",
    headers_products_search: [
      { text: "Foto", value: "photo" },
      { text: "Referência", value: "reference" },
      { text: "Nome", value: "name" },
      { text: "Categoria", value: "category_name" },
      { text: "Subcategoria", value: "subcategory_name" },
    ],
    headers_products: [
      { text: "Foto", value: "photo" },
      { text: "Referência", value: "reference" },
      { text: "Nome", value: "name" },
      { text: "Preço Rede", value: "price_cif", align: "right" },
      { text: "Novo Preço Rede", value: "new_price_cif", align: "right" },
      { text: "% Rede", value: "percent_cif", align: "right" },
      { text: "Preço Mult.", value: "price_mult", align: "right" },
      { text: "Novo Preço Mult.", value: "new_price_mult", align: "right" },
      { text: "% Mult.", value: "percent_mult", align: "right" },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    products_search: [],
    dialog_zoom_photo: false,
    photo_dialog: "",
    products: [],
    alert_add_product: "",
    panel: 0,
  }),
  filters: {
    formatPercent: function (value) {
      return parseFloat(value).toFixed(2);
    },
  },
  watch: {
    radio_payment_condition(older_value, new_value) {
      if (new_value === "one") {
        this.promotion.payment_condition_id = "";
      }
    },
    tab(new_tab) {
      if (new_tab === 2) {
        this.getCollections(this.promotion.provider_id);
        this.getCategories(this.promotion.provider_id);
        this.getSubcategories(this.promotion.provider_id);
        this.getMaterials(this.promotion.provider_id);
        this.getColors(this.promotion.provider_id);
        this.getTechnologies(this.promotion.provider_id);
      }
    },
    selected(newValue) {
      console.log(newValue);
    },
  },
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getProviders();
      this.getPaymentConditions();
      if (this.$route.params.id) {
        this.getPromotion(this.$route.params.id);
      }
    },
    goToBackList() {
      this.$router.push({ name: "ProviderPromotions" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        let data = {
          promotion: {
            ...this.promotion,
            description: this.promotion.description.toUpperCase(),
            start_date: this.dateFormatToEua(this.promotion.start_date),
            end_date: this.dateFormatToEua(this.promotion.end_date),
          },
          products: this.products,
        };

        // if (data.promotion.type === 3) {
        data.products = data.products.map((item) => ({
          ...item,
          new_price_cif: this.priceBr2Eua(item.new_price_cif),
          new_price_mult: this.priceBr2Eua(item.new_price_mult),
        }));
        // }

        console.log(data);
        if (this.promotion.id === "") {
          this.post(data);
        } else {
          this.update(this.promotion.id, data);
        }
      }
    },
    async getPromotion(id) {
      this.loading = true;
      try {
        let response = await CompanyPromotionAPI.getById(id);
        this.promotion = response.promotion;
        this.products = response.products;

        // TRATANDO DATA INICIAL
        this.promotion.start_date =
          this.promotion.start_date !== ""
            ? this.dateFormatToBr(this.promotion.start_date)
            : this.promotion.start_date;

        // TRATANDO DATA FINAL
        this.promotion.end_date =
          this.promotion.end_date !== ""
            ? this.dateFormatToBr(this.promotion.end_date)
            : this.promotion.end_date;

        // TRATANDO CONDIÇÃO DE PAGAMENTO
        this.radio_payment_condition =
          this.promotion.payment == null ? "all" : "one";

        // TRATANDO RADIO BUTTON DE PRODUTOS
        this.radio_products =
          response.products.length === 0 ? "all_products" : "some_products";
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getProviders() {
      if (this.providers.length == 0) {
        this.loading_providers = true;
        try {
          let data = await CompanyAPI.getAll("?type=for");
          this.providers = data.sort((a, b) => (a.code > b.code ? 1 : -1));
        } catch (error) {
          this.providers = [];
          console.log(error);
        } finally {
          this.loading_providers = false;
        }
      }
    },
    async getPaymentConditions() {
      this.loading = true;
      this.payment_conditions = [];
      try {
        let res = await fetch(`${URL}payment-condition`);
        let data = await res.json();
        this.payment_conditions = data.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getCollections(provider) {
      if (
        this.collections.length == 0 ||
        this.provider_id_last_search !== this.promotion.provider_id
      ) {
        this.loading_collections = true;
        this.collections = [];
        try {
          let response = await fetch(
            `${URL}order/collection?provider=${provider}`
          );
          let data = await response.json();
          this.collections = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.provider_id_last_search = provider;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading_collections = false;
        }
      }
    },
    async getCategories(provider) {
      if (
        this.categories.length == 0 ||
        this.provider_id_last_search !== this.promotion.provider_id
      ) {
        this.loading_categories = true;
        this.categories = [];
        try {
          let response = await fetch(
            `${URL}order/category?provider=${provider}`
          );
          let data = await response.json();
          this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.provider_id_last_search = provider;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading_categories = false;
        }
      }
    },
    async getSubcategories(provider) {
      if (
        this.subcategories.length == 0 ||
        this.provider_id_last_search !== this.promotion.provider_id
      ) {
        this.loading_subcategories = true;
        this.subcategories = [];
        try {
          let response = await fetch(
            `${URL}order/subcategory?provider=${provider}`
          );
          let data = await response.json();
          this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.provider_id_last_search = provider;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading_subcategories = false;
        }
      }
    },
    async getMaterials(provider) {
      if (
        this.materials.length == 0 ||
        this.provider_id_last_search !== this.promotion.provider_id
      ) {
        this.loading_materials = true;
        this.materials = [];
        try {
          let response = await fetch(
            `${URL}order/material?provider=${provider}`
          );
          let data = await response.json();
          this.materials = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.provider_id_last_search = provider;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading_materials = false;
        }
      }
    },
    async getTechnologies(provider) {
      if (
        this.technologies.length == 0 ||
        this.provider_id_last_search !== this.promotion.provider_id
      ) {
        this.loading_technologies = true;
        this.technologies = [];
        try {
          let response = await fetch(
            `${URL}order/technology?provider=${provider}`
          );
          let data = await response.json();
          this.technologies = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.provider_id_last_search = provider;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading_technologies = false;
        }
      }
    },
    async getColors(provider) {
      if (
        this.colors.length == 0 ||
        this.provider_id_last_search !== this.promotion.provider_id
      ) {
        this.loading_colors = true;
        this.colors = [];
        try {
          let response = await fetch(`${URL}order/color?provider=${provider}`);
          let data = await response.json();
          this.colors = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.provider_id_last_search = provider;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading_colors = false;
        }
      }
    },
    async post(data) {
      console.log(data);
      this.loading = true;
      try {
        await CompanyPromotionAPI.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        this.alert_message =
          "Erro ao salvar a promoção, tente novamente mais tarde";
        this.type_alert = "error";
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      console.log({ id });
      console.log(data);
      this.loading = true;
      try {
        await CompanyPromotionAPI.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        this.alert_message =
          "Erro ao atualizar a promoção, tente novamente mais tarde";
        this.type_alert = "error";
      } finally {
        this.loading = false;
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    handlerCalendar(field) {
      let date = this.promotion[field];
      this.date_dialog = this.dateFormatToEua(date);
      this.field_date = field;
      this.modal_date = true;
    },
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
    handlePickerDate() {
      this.promotion[this.field_date] = this.dateFormatToBr(this.date_dialog);
      this.field_date = "";
      this.date_dialog = "";
      this.modal_date = false;
    },
    async searchProductAdvanced() {
      this.products_search = [];
      this.selected = [];
      this.alert_add_product = "";
      this.loading_search = true;
      let params = { ...this.search };
      params.provider = this.promotion.provider_id;
      console.log(params);
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let response = await fetch(`${URL}product/search-provider-promotion`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(params),
        });
        let data = await response.json();
        this.products_search = data.products;
        this.panel = 1;
      } catch (error) {
        this.products_search = [];
        console.log(error);
      } finally {
        this.loading_search = false;
      }
    },
    getUrlPhoto(photo) {
      if (photo !== "") {
        return `${URL_IMAGE}${photo}`;
      } else {
        return "";
      }
    },
    onClickImage(photo) {
      if (photo == "") return;
      this.photo_dialog = photo;
      this.dialog_zoom_photo = true;
    },
    closeDialogZoomPhoto() {
      this.dialog_zoom_photo = false;
      this.photo_dialog = "";
    },
    deleteProduct(item) {
      let index = this.products.findIndex((prod) => prod.id === item.id);
      this.products.splice(index, 1);
    },
    goToPageTwo() {
      if (this.promotion.provider_id === "") {
        alert("Você precisa selecionar um fornecedor para poder avançar.");
        return false;
      }
      if (this.promotion.type == "") {
        alert("Você precisa selecionar o tipo de oportunidade.");
        return false;
      }
      if (this.promotion.type == 3) {
        this.radio_products = "some_products";
      }
      // if (this.$refs.form.validate()) {
      this.tab = 2;
      // }
    },
    goToPageTree() {
      if (
        this.radio_products === "some_products" &&
        this.products.length == 0
      ) {
        alert(
          "Você precisa adicionar os produtos na promoção para poder avançar"
        );
        return false;
      }
      if (this.selected.length > 0 && this.products.length == 0) {
        alert(
          "Você precisa adicionar os produtos na promoção para poder avançar"
        );
        return false;
      }
      if (this.promotion.type === 3) {
        this.tab = 3;
      } else {
        this.tab = 4;
      }
      // console.log(this.products);

      // if (this.$refs.form.validate()) {
      // }
    },
    goToPageFour() {
      if (this.selected.length > 0 && this.products.length == 0) {
        alert(
          "Você precisa adicionar os produtos na promoção para poder avançar"
        );
        return false;
      }
      this.tab = 4;
    },
    addProduct() {
      // console.log(this.selected);
      this.alert_add_product = "Produto(s) Adicionado(s) na Promoção";
      let products_selecteds = this.selected.filter(
        (item) =>
          this.products.find((prod) => prod.id === item.id) === undefined
      );

      if (this.promotion.type === 3) {
        products_selecteds = products_selecteds.map((item) => ({
          ...item,
          new_price_cif: this.localCurrencyBr(item.price_cif),
          new_price_mult: this.localCurrencyBr(item.price_mult),
          percent_cif: 0,
          percent_mult: 0,
        }));
      } else {
        products_selecteds = products_selecteds.map((item) => ({
          ...item,
          new_price_cif: this.localCurrencyBr(
            item.price_cif - item.price_cif / this.promotion.discount
          ),
          new_price_mult: this.localCurrencyBr(
            item.price_mult - item.price_mult / this.promotion.discount
          ),
          percent_cif: this.promotion.discount * -1,
          percent_mult: this.promotion.discount * -1,
        }));
      }

      // console.log(products_selecteds);
      this.products = this.products.concat(products_selecteds);
      setTimeout(() => {
        this.alert_add_product = "";
      }, 3000);
      console.log(this.products);
    },
    priceBr2Eua(value) {
      if (value === "") return "";
      return parseFloat(
        value.toString().replace(/\./gi, "").replace(/,/gi, ".")
      );
    },
    handleChangePrice(item, type) {
      if (type === "cif") {
        let newPrice = this.priceBr2Eua(item.new_price_cif);
        let price = parseFloat(item.price_cif);

        let percent = ((newPrice / price - 1) * 100).toFixed(2);
        console.log(newPrice);
        console.log(price);
        console.log(percent);
        item.percent_cif = percent;
      }
      if (type === "mult") {
        let newPrice = this.priceBr2Eua(item.new_price_mult);
        let price = parseFloat(item.price_mult);
        let percent = ((newPrice / price - 1) * 100).toFixed(2);
        item.percent_mult = percent;
      }
    },
    localCurrencyBr(value) {
      if (!value) return "";
      return value.toLocaleString("pt-br", { minimumFractionDigits: 2 });
    },
    goBackTab4() {
      if (this.promotion.type === 3) {
        this.tab = 3;
      } else {
        this.tab = 2;
      }
    },
  },
};
</script>
<style scoped>
.v-stepper__wrapper {
  overflow: auto !important;
}
.column-price {
  width: 200px;
}
.column-percent {
  width: 180px;
}
</style>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
